<template>
  <nav aria-label="Breadcrumb" class="app-breadcrumb">
    <transition-group tag="ol" name="breadcrumb" class="app-breadcrumb__list">
      <li
        v-for="(item, index) in levelList"
        :key="item.path"
        class="app-breadcrumb__item"
      >
        <svg-icon
          v-if="index > 0"
          icon-class="caret-right-bold"
          :class-name="
            index === levelList.length - 1
              ? 'app-breadcrumb__separator app-breadcrumb__separator--current'
              : 'app-breadcrumb__separator'
          "
        />
        <span
          v-if="index === levelList.length - 1"
          class="app-breadcrumb__current"
          aria-current="page"
          >{{ getTitle(item.meta.title) }}</span
        >
        <span
          v-else-if="item.redirect === 'noRedirect'"
          class="app-breadcrumb__text"
          >{{ getTitle(item.meta.title) }}</span
        >
        <a
          v-else
          href="#"
          class="app-breadcrumb__link"
          @click.prevent="handleLink(item)"
          >{{ item.meta.title }}</a
        >
      </li>
    </transition-group>
  </nav>
</template>

<script>
import pathToRegexp from 'path-to-regexp'

export default {
  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      if (route.path.startsWith('/redirect/')) {
        return
      }
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    getTitle(title) {
      return this.$t(title)
    },
    getBreadcrumb() {
      // only show routes with meta.title
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      const first = matched[0]

      if (!this.isDashboard(first)) {
        matched = [{ path: '/home', meta: { title: 'DMPeople' }}].concat(matched)
      }

      this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
    },
    isDashboard(route) {
      const name = route && route.name
      if (!name) {
        return false
      }
      return name.trim().toLocaleLowerCase() === 'DMPeople'.toLocaleLowerCase()
    },
    pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const { params } = this.$route
      var toPath = pathToRegexp.compile(path)
      return toPath(params)
    },
    handleLink(item) {
      const { redirect, path } = item
      if (redirect) {
        this.$router.push(redirect)
        return
      }
      this.$router.push(this.pathCompile(path))
    }
  }
}
</script>
